import Logger from "@/assets/Helper/Logger";

class DAOWishList {

    constructor() {
        this.maxItems = 30;
    }

    open(objectStoreId) {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open('wishlist', 1)

            request.onsuccess = function () {
                try {
                    let objectStore = request.result.transaction([objectStoreId], "readwrite").objectStore(objectStoreId);
                    resolve(objectStore);
                } catch (e) {
                    resolve(false);
                }
            };

            request.onupgradeneeded = function (event) {
                let db = event.target.result;

                let wishlist = db.createObjectStore('wishlist', {autoIncrement: true});
                wishlist.createIndex("date", "date", {unique: false});

                wishlist.onsuccess = function () {
                    let objectStore = db.transaction(['wishlist'], "readwrite").objectStore('wishlist');
                    if ('wishlist' === objectStoreId) {
                        resolve(objectStore);
                    }
                };

                let configure = db.createObjectStore('configure', {autoIncrement: true})
                configure.createIndex("date", "date", {unique: false});

                configure.onsuccess = function () {
                    let objectStore = db.transaction(['configure'], "readwrite").objectStore('configure');
                    if ('configure' === objectStoreId) {
                        resolve(objectStore);
                    }
                };

                let history = db.createObjectStore('history', {autoIncrement: true});
                history.createIndex("date", "date", {unique: false});

                history.onsuccess = function () {
                    let objectStore = db.transaction(['history'], "readwrite").objectStore('history');
                    if ('history' === objectStoreId) {
                        resolve(objectStore);
                    }
                };

                let diamonds = db.createObjectStore('diamonds', {autoIncrement: true});
                diamonds.createIndex("date", "date", {unique: false});

                diamonds.onsuccess = function () {
                    let objectStore = db.transaction(['diamonds'], "readwrite").objectStore('diamonds');
                    if ('diamonds' === objectStoreId) {
                        resolve(objectStore);
                    }
                };
            }

            request.onerror = function () {
                reject('error');
            };
        });
    }

    add(objectStoreId, items) {
        return new Promise((resolve, reject) => {
            this.open(objectStoreId)
                .then(objectStore => {
                let request = objectStore.add(items);

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                };

                request.onerror = function () {
                    reject("failed to add");
                }
            }).catch((error) => {
                Logger.debug("indexdb not available", error);
                reject("failed to add");
            });
        });
    }

    dropLastIfLimitReached(objectStoreId) {
        this.getAll(objectStoreId).then(itemList => {
            if ((objectStoreId === 'configure' || objectStoreId === 'history') && itemList.length >= this.maxItems) {
                this.drop(objectStoreId, itemList[itemList.length - 1].primaryKey);
            }
        });
    }

    getDiamond(id) {
        return new Promise((resolve) => {
            this.open('diamonds')
                .then(objectStore => {
                    objectStore.openCursor().onsuccess = function (event) {
                        let cursor = event.target.result;
                        if (cursor) {
                            let found = false;

                            if (cursor.value.id === id) {
                                found = true;
                            }

                            if (found === true) {
                                resolve(cursor.primaryKey);
                            }

                            cursor.continue();
                        }
                    };

                    objectStore.transaction.oncomplete = function () {
                        resolve(false);
                    }
                })
                .catch((error) => {
                    Logger.debug("indexdb not available", error);
                    resolve(false);
                });
        });
    }

    drop(objectStoreId, itemId) {
        return new Promise((resolve, reject) => {
            this.open(objectStoreId).then(objectStore => {
                if (itemId != null) {
                    let request = objectStore.delete(itemId);

                    request.onsuccess = function () {
                        console.log('deleted ' + itemId + ' from ' + objectStoreId);
                        resolve();
                    };

                    request.onerror = function () {
                        reject("failed to update");
                    }
                }
            }).catch((error) => {
                Logger.debug("indexdb not available", error);
                reject("failed to update");
            });
        });
    }

    update(objectStoreId, itemId, items) {
        return new Promise((resolve, reject) => {
            this.open(objectStoreId).then(objectStore => {
                if (itemId !== null && itemId !== 0 && items.items.length > 0) {
                    let request = objectStore.put(items, itemId);

                    request.onsuccess = function () {
                        resolve(itemId);
                    };

                    request.onerror = function () {
                        reject("failed to update");
                    }
                }
            }).catch((error) => {
                Logger.debug("indexdb not available", error);
                reject("failed to update");
            });
        });
    }

    getAll(objectStoreId) {
        return new Promise((resolve, reject) => {
            this.open(objectStoreId).then(objectStore => {
                let list = [];
                if (objectStore && typeof objectStore.index == 'function') {
                    objectStore.index('date').openCursor().onsuccess = function (event) {
                        let cursor = event.target.result;
                        if (cursor) {
                            cursor.value.primaryKey = cursor.primaryKey;
                            list.push(cursor.value);
                            cursor.continue();
                        }
                    };

                    objectStore.transaction.oncomplete = function () {
                        resolve(list.reverse());
                    }

                    objectStore.transaction.onerror = function () {
                        reject('error');
                    }
                } else {
                    resolve(list);
                }
            }).catch((error) => {
                Logger.debug("indexdb not available", error);
                reject(error);
            });
        });
    }

    getByPrimaryKey(objectStoreId, primaryKey) {
        return new Promise((resolve, reject) => {
            this.open(objectStoreId).then(objectStore => {
                objectStore.get(primaryKey).onsuccess = function (event) {
                    resolve(event.target.result);
                };

                objectStore.transaction.onerror = function () {
                    reject('error');
                }
            }).catch((error) => {
                Logger.debug("indexdb not available", error);
                reject(error);
            });
        })
    }

    saveWishlist(data, apiHost) {
        return new Promise((resolve, reject) => {
            fetch(apiHost + '/v2/wishlist/save/', {
                method: 'POST',
                body: JSON.stringify(data)
            }).then((response) => {
                resolve(response.json());
            }).catch(() => {
                reject(false);
            });
        });
    }

    getWishlist(data, apiHost) {
        return new Promise((resolve, reject) => {
            fetch(apiHost + '/v2/wishlist/get/', {
                method: 'POST',
                body: JSON.stringify(data)
            }).then((response) => {
                resolve(response.json());
            }).catch(() => {
                reject(false);
            });
        });
    }

    setWishlistFromDB(wishlist) {
        return new Promise((resolve, reject) => {
            this.getAll('wishlist')
                .then(configurationList => {
                    if (typeof configurationList == 'object' && configurationList.length > 0) {
                        for (let i in configurationList) {
                            this.drop('wishlist', configurationList[i].primaryKey);
                        }
                    }
                }).then(() => {
                    for (let i in wishlist) {
                        this.add('wishlist', wishlist[i]);
                    }
                    resolve(true);
                }).catch(() => {
                    reject(false);
                });
        });
    }

    getWishlistAuth(storageKey) {
        let wishlistAuth = '';
        if (typeof localStorage != 'undefined') {
            let result = localStorage.getItem(storageKey);
            if (result) {
                result = JSON.parse(result);
                if (result.wishlist && typeof result.wishlist.auth === 'string') {
                    wishlistAuth = result.wishlist.auth;
                }
            }
        }
        return wishlistAuth;
    }

    setWishlistAuth(storageKey, wishlistAuth) {
        if (typeof localStorage != 'undefined') {
            let storageData = localStorage.getItem(storageKey);

            storageData = storageData ? JSON.parse(storageData) : {};
            storageData.wishlist = storageData.wishlist ? storageData.wishlist : {};
            storageData.wishlist.auth = wishlistAuth;

            localStorage.setItem(storageKey, JSON.stringify(storageData));
            return true;
        }
        return false;
    }
}

export default new DAOWishList;
